<template>
  <div class="row">
    <!-- Filter by commodity type-->
    <div class="select-category col-6 offset-3">
      <div class="row categories">
        <div
          class="category-div col-4"
          :class="{ 'active': filterType=='all' }"
          @click="filterType='all'"
        >All</div>
        <div
          class="category-div col-4"
          :class="{ 'active': filterType=='vegetable' }"
          @click="filterType='vegetable'"
        >Vegetables</div>
        <div
          class="category-div col-4"
          :class="{ 'active': filterType=='fruit' }"
          id="last-category"
          @click="filterType='fruit'"
        >Fruits</div>
      </div>
    </div>
    <!-- Filter by commodity type ends-->
    <div class="select-commodities col-12" v-if="user=='admin'">
      <!-- assign commdoities row -->
      <div class="row" v-if="user=='admin'">
        <div class="selected-elements test">
          <img class="check-box" :src="checkBox" @click="clearSelected" />
          <span
            class="selected-label"
            :class="{ active: commoditiesSelected }"
          >{{commoditiesSelected ? commoditiesSelected + ' Selected' : 'Select'}}</span>
        </div>
        <div class="col"></div>
        <div class="assign-commodities test">
          <div
            class="assign-optionlist"
            :class="{ 'disabled': !commoditiesSelected }"
            @click="assignOptions"
          >
            <span>{{assignedOption ? assignedOption: 'Assign'}}</span>
            <div
              v-if="openOptions"
              class="assign-option"
              @click="assignedOption='Individual'"
            >Individual</div>
            <div v-if="openOptions" class="assign-option" @click="assignedOption='Group'">Group</div>
          </div>
        </div>
      </div>

      <!-- assign commodities row ends -->
    </div>
    <div class="commodities" :class="{'positioned': user=='admin'}">
      <div class="noCommodity" v-if="!displayedCommodities.length">
        <div class="text-center">
          <img src="../../assets/img/illu.svg" />
        </div>
        <div
          class="text-center deadline"
        >No {{filterType=='all' ? 'commodities':filterType + 's'}} in your configuration</div>
      </div>
      <div v-else>
        <div class="commodity-row">
          <!-- commodity card (note: we are looping for 6 items at a time)-->
          <div
            class="commodity"
            v-for="(commodity, index) in displayedCommodities.commodities.slice(0, 6)"
            :key="index"
            :class="{ 'maximized': maximized, 'firstrow':!((index)%6) }"
          >
            <img class="commodity-image" :src="getCommodityImage(commodity.img)" />
            <img
              class="image-checkbox"
              :src="commodity.selected ? getImageUrl('commoditychecked.svg') : getImageUrl('commodityunchecked.svg')"
              v-if="user=='admin'"
              @click="setSelected(index)"
            />
            <img
              class="add-commodity"
              src="../../assets/commodities/add.svg"
              @click="openTemplate(commodity.label.toLowerCase())"
            />
            <div class="commodity-name">{{commodity.label}}</div>
          </div>
          <!-- commodity card ends-->
          <!-- empty cards so that justify-content: space between can work correctly -->
          <div
            class="fill-images commodity"
            v-for="(item, index) in 6-(displayedCommodities.commodities.slice(0, 6).length)"
            :key="index"
          >
            <img
              class="commodity-image"
              :src="getCommodityImage(displayedCommodities.commodities[0].img)"
            />
            <img
              class="image-checkbox"
              :src="displayedCommodities.commodities[0].selected ? getImageUrl('commoditychecked.svg') : getImageUrl('commodityunchecked.svg')"
              v-if="user=='admin'"
              @click="setSelected(index)"
            />
            <img
              class="add-commodity"
              src="../../assets/commodities/add.svg"
              @click="openTemplate(displayedCommodities.commodities[0].label.toLowerCase())"
            />
            <div class="commodity-name">{{displayedCommodities.commodities[0].label}}</div>
          </div>
        </div>
        <div class="commodity-row">
          <!-- commodity card (note: we are looping for 6 items at a time)-->
          <div
            class="commodity"
            v-for="(commodity, index) in displayedCommodities.commodities.slice(6)"
            :key="index"
            :class="{ 'maximized': maximized, 'firstrow':!((index)%6) }"
          >
            <img class="commodity-image" :src="getCommodityImage(commodity.img)" />
            <img
              class="image-checkbox"
              :src="commodity.selected ? getImageUrl('commoditychecked.svg') : getImageUrl('commodityunchecked.svg')"
              v-if="user=='admin'"
              @click="setSelected(index)"
            />
            <img
              class="add-commodity"
              src="../../assets/commodities/add.svg"
              @click="openTemplate(commodity.label.toLowerCase())"
            />
            <div class="commodity-name">{{commodity.label}}</div>
          </div>
          <!-- commodity card ends-->
          <!-- empty cards so that justify-content: space between can work correctly -->
          <div
            class="fill-images commodity"
            v-for="(item, index) in 6-(displayedCommodities.commodities.slice(6).length)"
            :key="index"
          >
            <img
              class="commodity-image"
              :src="getCommodityImage(displayedCommodities.commodities[0].img)"
            />
            <img
              class="image-checkbox"
              :src="displayedCommodities.commodities[0].selected ? getImageUrl('commoditychecked.svg') : getImageUrl('commodityunchecked.svg')"
              v-if="user=='admin'"
              @click="setSelected(index)"
            />
            <img
              class="add-commodity"
              src="../../assets/commodities/add.svg"
              @click="openTemplate(displayedCommodities.commodities[0].label.toLowerCase())"
            />
            <div class="commodity-name">{{displayedCommodities.commodities[0].label}}</div>
          </div>
        </div>
        <!-- pagination -->
        <div class="commodity-pages col-12" v-if="commodities.length>12">
          <span
            class="page-change"
            :class="{ 'active': currentPage!=1 }"
            @click="currentPage==1 ? 1 : currentPage--"
          >Prev</span>
          <span
            class="page-no"
            v-for="(page, index) in (~~(displayedCommodities.length/13)+1)"
            :key="index"
            :class="{ 'active': index+1==currentPage }"
            @click="currentPage=index+1"
          >{{index+1}}</span>
          <!-- used bitwise shift(~~) to get the integer part of the quotient-->
          <span
            class="page-change"
            :class="{ 'active': currentPage != (~~(displayedCommodities.length/13)+1) }"
            @click="currentPage == (~~(displayedCommodities.length/13)+1) ? currentPage : currentPage++ "
          >Next</span>
        </div>
        <!-- pagination ends-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Commodities",
  data() {
    return {
      openOptions: false,
      assignCommodities: true,
      commoditiesSelected: 0,
      assignedOption: "",
      currentPage: 1,
      filterType: "all",
      commodities: [
        // {
        //   label: "Onion",
        //   img: "Onion.svg",
        //   type: "vegetable",
        //   selected: false
        // },
        {
          label: "Potato",
          img: "Potato.svg",
          type: "vegetable",
          selected: false
        }
        /*{
                    label: 'Apple',
                    img: 'Apple.svg',
                    type: 'fruit',
                    selected: false,
                },
                {
                    label: 'Corriander',
                    img: 'Corriander.svg',
                    type: 'vegetable',
                    selected: false,
                },*/
      ],
      allowedCommodity: []
    };
  },
  props: ["maximized"],
  computed: {
    user() {
      return this.$store.state.user;
    },
    // changes checkbox image on click
    checkBox() {
      return require("@/assets/icons/Commodities/" +
        (this.commoditiesSelected ? "checkedbox.svg" : "uncheckedbox.svg"));
    },
    userCommodities() {
      if (this.$store.state.cmdgroup)
        return this.$store.state.cmdgroup.commodities;
      return [];
    },
    // returns commodities in a set of 12
    displayedCommodities() {
      var currentCommodities = this.allowedCommodity;
      if (this.filterType != "all") {
        this.currentPage = 1;
        currentCommodities = currentCommodities.filter(
          item => item.type == this.filterType
        );
      }

      var returnedCommodities = {
        commodities: [],
        length: currentCommodities.length
      };

      if (!currentCommodities.length) {
        return returnedCommodities;
      }
      currentCommodities = currentCommodities.slice(
        (this.currentPage - 1) * 12,
        this.currentPage * 12
      );
      returnedCommodities.commodities = currentCommodities;
      return returnedCommodities;
    }
  },
  methods: {
    // images in a loop won't be compiled by webpack. So we are asserting their existence before compilation
    getImageUrl(url) {
      return require("@/assets/icons/Commodities/" + url);
    },
    getCommodityImage(url) {
      return require("@/assets/images/testimages/" + url);
    },
    // selects a commodity and counts the no of commodities selected
    setSelected(index) {
      if (this.commodities[index].selected) {
        this.commoditiesSelected--;
      } else {
        this.commoditiesSelected++;
      }
      this.commodities[index].selected = !this.commodities[index].selected;
    },
    // clears selection
    clearSelected() {
      if (this.commoditiesSelected) {
        for (const commodity of this.commodities) {
          commodity.selected = false;
          this.commoditiesSelected = 0;
        }
      }
    },
    // closes/opens the assign dropdown
    assignOptions(e) {
      if (!this.commoditiesSelected) {
        return;
      }
      this.openOptions = !this.openOptions;
    },
    // opens the report generation template for the selected commodity
    openTemplate(commodity) {
      this.$store.dispatch("showNonEditableSamples", false);
      this.$store.dispatch("selectCommodity", commodity);
      this.$router.push(
        "/app/secure/inspectionTemplate/generalInfo/" + commodity
      );
    }
  },
  created() {
    this.$store.dispatch("showLoader", true);
    // sets the path(bread crumbs) to be shown
    this.$store.commit("changePathLabel", {
      view: "All Commodities",
      categories: []
    });
    this.$store.dispatch("showLoader", false);
    this.allowedCommodity = this.commodities.filter(element =>
      this.userCommodities.includes(element.label)
    );
  }
};
</script>

<style scoped>
/*
    NOTE: ROWS ARE NOT CORRECTLY STACKING BELOW ONE ANOTHER, SO WE HAD TO MANUALLY POSITION THEM.
    FIX IT IF POSSIBLE
*/
.row {
  width: inherit !important;
}

textarea {
  resize: none;
}
.category-div.active {
  background-color: #24c656;
  color: white;
}

.select-category {
  background-color: white;
  height: 38px;
  border: 1px solid #24c656;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0px;
  min-width: 425px !important;
  max-width: 425px !important;
  margin: 0 auto;
}

.category-div {
  border-right: 1px solid #24c656;
  height: 37px;
  transition: 0.2s;
  text-align: center;
  vertical-align: middle;
  line-height: 38px;
  color: #24c656;
  cursor: pointer;
}

.category-div:hover {
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.2);
}

.categories {
  margin: 0 auto;
}

#last-category {
  border: none;
}

.commodities {
  position: absolute;
  top: 180px;
  min-width: 1015px;
  width: 100%;
  margin: 0 auto;
  display: inline-block;
  padding-left: 15px;
  padding-right: 35px;
  height: calc(100vh - 240px);
  overflow-y: visible;
}

/* changing position to reduce the gap left by assign commodities row */
.commodities.positioned {
  top: 230px;
}

.commodity {
  position: relative;
  min-width: calc((100vw - 520px) / 6);
  height: max-content;
  flex-grow: 0;
  flex-shrink: 0;
  border: 0px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  display: inline-block;
  margin-left: 20px;
  margin-bottom: 35px;
  box-shadow: 10px 10px 24px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: 0.2s;
}
.commodity:hover {
  box-shadow: 0px 1px 35px rgba(0, 0, 0, 0.25);
}
.commodity.maximized.firstrow {
  margin-left: 30px;
}

.commodity-image {
  width: 100%;
  height: 85%;
  flex-grow: 0;
  flex-shrink: 0;
}

.commodity-name {
  text-align: center;
  background: white;
  height: 30px;
  vertical-align: middle;
  line-height: 30px;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.add-commodity {
  opacity: 0;
  height: calc(100% - 30px);
  width: 100%;
  padding: 25%;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0px;
  left: 0px;
  transition: 0.1s;
  flex-grow: 0;
  flex-shrink: 0;
}

.add-commodity:hover {
  opacity: 1;
}

.select-commodities {
  position: absolute;
  height: 38px;
  top: 160px;
  padding: 0px 22px 0px 42px;
}

.test {
  width: 97px;
  height: 38px;
  float: left;
  vertical-align: middle;
  line-height: 38px;
  margin-left: 20px;
}

.assign-commodities {
  text-align: right;
  background: #f2f2f2;
  z-index: 10;
}

.assign-option {
  position: relative;
  bottom: 2px;
  height: 30px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 30px;
  vertical-align: middle;
  text-align: center;
  background: #24c656;
  box-shadow: 2px 0px 10px -9px rgba(0, 0, 0, 0.3);
  color: #ffffff;
}

.assign-option:hover {
  background: #24a35a;
}

.assign-optionlist {
  height: 38px;
  line-height: 38px;
  text-align: center;
  vertical-align: middle;
  cursor: default;
  border: 1px solid #24c656;
  box-sizing: border-box;
  border-radius: 4px;
  color: #24c656;
  background: #fff;
}

.assign-optionlist.disabled {
  border-color: #b4b4b4;
  color: #b4b4b4;
}

.assign-optionlist.disabled:hover {
  box-shadow: none;
}

.assign-optionlist:hover {
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
}

.selected-label.active {
  color: #24c656;
}

.selected-label {
  color: #b4b4b4;
  position: relative;
  left: 5px;
  top: 2px;
}

.commodity-pages {
  height: 38px;
  width: 205px;
  margin-top: 30px;
  padding-left: 20px;
}

.page-no,
.page-change {
  margin-left: 15px;
  margin-right: 15px;
  cursor: pointer;
  color: #000;
}

.page-no.active {
  color: #24c656;
}

.image-checkbox {
  position: absolute;
  top: 10%;
  right: 10%;
  width: 10%;
  height: 10%;
  z-index: 10;
}

.page-change.active {
  color: #24c656;
}

.check-box {
  cursor: pointer;
}
.commodity-row {
  width: 98.5%;
  display: flex;
  justify-content: space-between;
}

.fill-images,
.fill-images div,
.fill-images img {
  visibility: hidden !important;
  box-shadow: none !important;
}

.deadline {
  margin-top: 39px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  color: #24c656;
}
</style>
